// extracted by mini-css-extract-plugin
export default {"overlay":"PostModal_overlay__TFMM2","postModal":"PostModal_postModal__m2gd6","postItems":"PostModal_postItems__VdSE4","postItem":"PostModal_postItem__hv8M5"};